<template>
    <div ref="appHeader" v-bind:class="{ 'mb-3': !noMargin }"
        class="navbar navbar-expand-md navbar-light bg-white border-bottom box-shadow header-z">
        <div class="container-fluid">
            <router-link class="navbar-brand" to="/home">
                <img v-bind:src="require('@/assets/sms-logo.png')" class="img-fluid ms-3" alt="Logo" />
            </router-link>

            <button @click="this.$store.state.hiddenBody = !this.$store.state.hiddenBody" class="navbar-toggler"
                type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav"
                aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>


            <div class="collapse navbar-collapse responsive-header-menu flex-grow-1" id="navbarNav"
                @click="handleResponsiveNavClick">
                <ul class="navbar-nav">

                    <!-- Map -->
                    <li class="nav-item">
                        <router-link class="btn-menu btn me-1" :class="{ 'active-btn': this.mapBtn }"
                            to="/home"><font-awesome-icon :icon="['fas', 'location-dot']"
                                class="mx-2" />Carte</router-link>
                    </li>

                    <!-- Vehicles -->
                    <li v-if="!this.$isAdmin && !this.$isOperator" class="nav-item">
                        <router-link class="btn-menu btn me-1" :class="{ 'active-btn': this.vehicleBtn }"
                            to="/baliseslist"><font-awesome-icon :icon="['fas', 'car']"
                                class="mx-2" />Véhicules</router-link>
                    </li>
                    <li v-else class="nav-item">
                        <router-link class="btn-menu btn me-1" :class="{ 'active-btn': this.vehicleBtn }"
                            to="/baliseslistall"><font-awesome-icon :icon="['fas', 'car']"
                                class="mx-2" />Véhicules</router-link>
                    </li>

                    <!-- Advanced security features -->
                    <li class="nav-item dropdown">
                        <button type="button" class="btn-menu btn dropdown-toggle me-1" data-bs-toggle="dropdown"
                            aria-expanded="false" :class="{ 'active-btn': this.secuBtn }">
                            <font-awesome-icon :icon="['fas', 'shield-halved']" class="mx-2" />
                            Fonctions sécurité
                        </button>
                        <ul class="dropdown-menu">
                            <li><router-link class="dropdown-item" to="/corridoringlist">Corridoring</router-link>
                            </li>
                            <li><router-link class="dropdown-item" to="/geofencingmap">Geofencing</router-link></li>
                            <li><router-link class="dropdown-item" to="/missionslist">Missions</router-link></li>
                            <li><router-link class="dropdown-item" to="/missionshistory">Historique</router-link></li>
                            <li><router-link class="dropdown-item" to="/missionsmembers">Chauffeurs</router-link></li>
                        </ul>
                    </li>

                    <!-- Administration -->
                    <li v-if="!this.isViewer && !this.$isOperator && !this.isClientUser" class="nav-item dropdown">
                        <button type="button" class="btn-menu btn dropdown-toggle me-1" data-bs-toggle="dropdown"
                            aria-expanded="false" :class="{ 'active-btn': this.adminBtn }">
                            <font-awesome-icon :icon="['fas', 'user-gear']" class="mx-2" />
                            Administration
                        </button>
                        <ul class="dropdown-menu">
                            <li><router-link class="dropdown-item" to="/users">Gestion des utilisateurs</router-link>
                            </li>
                            <li><router-link class="dropdown-item" to="/groups">Gestion des groupes</router-link></li>
                            <li><router-link class="dropdown-item" to="/contacts">Gestion des contacts</router-link>
                            </li>
                            <hr>
                            <li><router-link class="dropdown-item" to="/badgeslist">Badges</router-link></li>
                            <li><router-link class="dropdown-item" to="/badgeprofileslist">Profils de
                                    badges</router-link></li>
                            <hr>
                            <li><router-link class="dropdown-item" to="/patchnotes">Mises à jour</router-link></li>
                        </ul>
                    </li>

                    <!-- Client selection for superadmin & superoperators -->
                    <li v-if="this.$isAdmin || this.$isOperator" class="nav-item">
                        <button class="btn-menu btn me-1" type="button" data-bs-toggle="modal"
                            data-bs-target="#clientSelectorModal">
                            Client : {{ watchedClientName }}
                        </button>
                    </li>

                    <!-- Monitoring for super admins -->
                    <li v-if="this.$isAdmin" class="nav-item dropdown">
                        <button type="button" class="btn-menu btn btn-primary dropdown-toggle me-1"
                            data-bs-toggle="dropdown" aria-expanded="false">Super admin</button>
                        <ul class="dropdown-menu">
                            <!--<li>
                                <router-link class="dropdown-item" to="/balisecmd">Commandes</router-link>
                            </li>-->
                            <!--<li>
                                <router-link class="dropdown-item" to="/baliseconfig">Config balises</router-link>
                            </li>-->
                            <li>
                                <router-link class="dropdown-item" to="/balise/admin/addbalise">Ajouter une
                                    Balise</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/billing">Facturation</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/clientpage">Config clients</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/dashboard">Dashboard</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/precheckcrud">Checks balise
                                    mission</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/missionauditlogs">Mission logs</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/newmap">Carte (Beta)</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/tutorial/mission">Tuto mission</router-link>
                            </li>
                            <li>
                                <router-link class="dropdown-item" to="/adminglobal">Server status</router-link>
                            </li>
                        </ul>
                    </li>

                    <!-- Monitoring for operators -->
                    <li v-if="this.$isOperator" class="nav-item dropdown">
                        <button type="button" class="btn-menu btn btn-primary dropdown-toggle me-1"
                            data-bs-toggle="dropdown" aria-expanded="false">Aide</button>
                        <ul class="dropdown-menu">
                            <li>
                                <router-link class="dropdown-item" to="/tutorial/mission">Tuto mission</router-link>
                            </li>
                        </ul>
                    </li>

                    <!-- Notifications -->
                    <li v-if="!this.isViewer" class="nav-item dropdown d-none d-lg-block">
                        <button type="button" class="btn-menu btn me-1 notification-icon" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <font-awesome-icon :icon="['fas', 'bell']" />
                            <span v-if="this.lastSeenPatchnote < this.$version" class="badge rounded-pill">1</span>
                        </button>
                        <ul class="dropdown-menu">
                            <li v-if="this.lastSeenPatchnote < this.$version">
                                <router-link class="dropdown-item" to="/patchnotes">Nouvelle version</router-link>
                            </li>
                            <li v-else>
                                <router-link class="dropdown-item disabled" to="/">Aucune notification</router-link>
                            </li>
                        </ul>
                    </li>
                    <!-- responsive notification -->
                    <li v-if="!this.isViewer" class="nav-item dropdown d-lg-none">
                        <button type="button" class="btn-menu btn me-1" data-bs-toggle="dropdown" aria-expanded="false">
                            <font-awesome-icon :icon="['fas', 'bell']" class="mx-2" />
                            <span v-if="this.lastSeenPatchnote < this.$version"
                                class="badge rounded-pill notification-badge">1</span>
                        </button>
                        <ul class="dropdown-menu">
                            <li v-if="this.lastSeenPatchnote < this.$version">
                                <router-link class="dropdown-item" to="/patchnotes">Nouvelle version</router-link>
                            </li>
                            <li v-else>
                                <router-link class="dropdown-item disabled" to="/">Aucune notification</router-link>
                            </li>
                        </ul>
                    </li>
                    <!-- Logout -->
                    <li class="nav-item">
                        <button class="btn-menu-dark btn-logout btn ms-5 me-4" @click.prevent="UserLogout">
                            <font-awesome-icon :icon="['fas', 'fa-right-from-bracket']" class="mx-2" />
                            Déconnexion
                        </button>
                    </li>

                    <!-- Add other navigation items here with the appropriate Bootstrap classes -->
                </ul>
            </div>
        </div>
    </div>

    <div v-if="this.$isAdmin || this.$isOperator" class="modal fade client-selector-modal" id="clientSelectorModal"
        tabindex="-1" aria-labelledby="clientSelectorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered client-selector-dialog">
            <div class="modal-content client-selector-content">
                <div class="modal-header client-selector-header">
                    <div>
                        <div class="client-selector-kicker">Sélection du client</div>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                </div>

                <div class="modal-body client-selector-body">
                    <div class="client-current-box mb-3">
                        <div class="small text-muted">Client actuellement sélectionné</div>
                        <div class="fw-bold client-current-name">{{ watchedClientName }}</div>
                    </div>

                    <div class="client-search-wrap mb-3">
                        <input v-model="clientSearch" type="text" class="form-control client-search-input"
                            placeholder="Rechercher un client..." />
                    </div>

                    <div class="client-selector-list">
                        <button type="button" class="client-option"
                            :class="{ 'client-option-active': watchedClientId === 0 }"
                            @click="setClientIdToWatch(0, 'Tous les clients')">
                            <div class="client-option-main">
                                <div class="client-option-title">Tous les clients</div>
                                <div class="client-option-subtitle">Afficher l'ensemble des clients</div>
                            </div>
                        </button>

                        <button v-for="client in filteredClients" :key="client.id" type="button" class="client-option"
                            :class="{ 'client-option-active': watchedClientId === client.id }"
                            @click="setClientIdToWatch(client.id, client.name)">
                            <div class="client-option-main">
                                <div class="client-option-title">{{ client.name }}</div>
                            </div>
                        </button>

                        <div v-if="filteredClients.length === 0" class="client-empty-state">
                            Aucun client ne correspond à votre recherche.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClientService from '@/services/client.service.js'
import UserHelper from '@/helpers/user.helper.js'
import { writeUserPageFilters } from "@/helpers/localUserFilterStorage.js";

export default {
    props: ['noMargin'],
    data() {
        return {
            watchedClientId: null,
            navBarOpened: false,
            clientList: null,
            clientSearch: "",
            watchedClientName: "Clients",
            lastSeenPatchnote: 0,
            routesOnClientChange: {
                "MapFollowBalise": "/",
                "MissionWizardCreate": "/missionslist",
                "MissionWizardName": "/missionslist",
                "MissionWizardTransporteur": "/missionslist",
                "MissionWizardDrivers": "/missionslist",
                "MissionWizardConvoy": "/missionslist",
                "MissionWizardPlates": "/missionslist",
                "MissionInfo": "/missionslist",
                "MissionMap": "/missionslist",
                "MissionHistoryMap": "/missionslist",
            },
        };
    },
    computed: {
        clients() {
            if (this.clientList === null)
                return JSON.parse(localStorage.getItem('clients'));

            return this.clientList;
        },
        filteredClients() {
            const list = Array.isArray(this.clients) ? this.clients : [];
            const search = String(this.clientSearch || '').trim().toLowerCase();
            if (!search) return list;
            return list.filter(client =>
                String(client.name || '').toLowerCase().includes(search)
            );
        },
        isViewer() {
            return UserHelper.isViewer(this.$store.state.auth.user);
        },
        isClientUser() {
            return UserHelper.isClientUser(this.$store.state.auth.user);
        },
        storeWatchedClientId() {
            return JSON.parse(localStorage.getItem('clientIdToWatch'));
        },
        storeWatchedClientName() {
            return JSON.parse(localStorage.getItem('clientNameToWatch'));
        },
        storeLastSeenPatchnote() {
            return JSON.parse(localStorage.getItem('lastSeenPatchnote'));
        },
        // Properties to know what button is selected for the current page :
        mapBtn() {
            if (this.$route.name == "MapPage") {
                return true
            } else {
                return false
            }
        },
        vehicleBtn() {
            if (this.$route.name == "BalisesList"
                || this.$route.name == "BaliseInfo"
                || this.$route.name == "PositionsPage"
                || this.$route.name == "DrivesPage"
                || this.$route.name == "AlertsPage"
                || this.$route.name == "DrivePositionsPage"
                || this.$route.name == "BalisesListAll"
            ) {
                return true
            } else {
                return false
            }
        },
        adminBtn() {
            if (this.$route.name == "UsersPage"
                || this.$route.name == "GroupsPage"
                || this.$route.name == "PatchNotes"
                || this.$route.name == "BadgeInfo"
                || this.$route.name == "BadgesList"
                || this.$route.name == "BadgeAlarmsList"
                || this.$route.name == "BadgeProfilesList"
            ) {
                return true
            } else {
                return false
            }
        },
        secuBtn() {
            if (this.$route.name == "CorridoringList"
                || this.$route.name == "MissionsList"
            ) {
                return true
            } else {
                return false
            }
        }
        // End properties define
    },
    beforeCreate() {
        this.$store.state.hiddenBody = false;
    },
    mounted() {
        // hauteur/offset initiaux
        this.updateHeaderHeight();
        // maj sur resize fenêtre
        window.addEventListener('resize', this.updateHeaderHeight, { passive: true });
        // maj en cas de variation de taille du header (menus, police, lignes de menu, etc.)
        this._ro = new ResizeObserver(() => this.updateHeaderHeight());
        if (this.$refs.appHeader) this._ro.observe(this.$refs.appHeader);
        if ((this.$isAdmin || this.$isOperator) && !this.clients) {
            ClientService.getClients().then(response => {
                localStorage.setItem('clients', JSON.stringify(response.data));
                this.clientList = JSON.parse(localStorage.getItem('clients'));
                // ⬇️ Par défaut : "Tous les clients"
                if (this.storeWatchedClientId === null || this.storeWatchedClientId === undefined) {
                    localStorage.setItem('clientIdToWatch', JSON.stringify(0));
                    localStorage.setItem('clientNameToWatch', JSON.stringify('Tous les clients'));
                }
                this.watchedClientId = (this.storeWatchedClientId !== null && this.storeWatchedClientId !== undefined)
                    ? this.storeWatchedClientId
                    : 0;
                this.watchedClientName = (this.storeWatchedClientName !== null && this.storeWatchedClientName !== undefined)
                    ? this.storeWatchedClientName
                    : 'Tous les clients';
                location.reload();
            });
        }
        // ⬇️ Prend bien en compte 0 (falsy) comme valeur valide
        if (this.storeWatchedClientId !== null && this.storeWatchedClientId !== undefined) {
            this.watchedClientId = this.storeWatchedClientId;
            this.watchedClientName = this.storeWatchedClientName || 'Tous les clients';
        }
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateHeaderHeight);
        if (this._ro) { this._ro.disconnect(); this._ro = null; }
        this.cleanupModalArtifacts();
    },
    beforeUpdate() {
        this.lastSeenPatchnote = this.storeLastSeenPatchnote;
    },
    methods: {
        UserLogout() {
            this.closeResponsiveMenu();
            this.cleanupModalArtifacts();
            this.$store.dispatch('auth/logout').then(() => {
                this.$router.push('/');
            },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        cleanupModalArtifacts() {
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('padding-right');
            document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        },
        closeClientSelectorModal() {
            const modalEl = document.getElementById('clientSelectorModal');

            if (modalEl && window.bootstrap?.Modal) {
                const instance = window.bootstrap.Modal.getInstance(modalEl);
                if (instance) {
                    instance.hide();
                }
            }

            this.cleanupModalArtifacts();
        },
        setClientIdToWatch(clientId, clientName) {
            // Sécurité : seuls admin / opérateur peuvent changer de client
            if (!this.$isAdmin && !this.$isOperator) return;
            this.closeClientSelectorModal();
            writeUserPageFilters(this.$store?.state?.auth?.user?.id, "main-map", {
                visibleGroupIds: null,
            });
            localStorage.setItem('clientIdToWatch', JSON.stringify(clientId));
            localStorage.setItem('clientNameToWatch', JSON.stringify(clientName));
            this.clientSearch = '';

            // Si on vient du placeholder avec une cible, on y retourne
            if (this.$route.name === 'ClientRequired' && this.$route.query.from) {
                this.$router.push(this.$route.query.from);
                return;
            }

            const nextPath = this.routesOnClientChange[this.$route.name] || "/baliseslist";

            if (nextPath) {
                // Si on est déjà sur la destination, on force un reload pour re-fetch les données
                if (this.$route.path === nextPath) {
                    location.reload();
                } else {
                    this.$router.push(nextPath).then(() => {
                        location.reload();
                    });
                }
            }
        },
        // enregistre la taille du header dans une variable CSS pour usage par le panneau latéral de la map
        updateHeaderHeight() {
            const el = this.$refs.appHeader;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            // Hauteur utile (fallback) et surtout OFFSET (position du bas du header dans la fenêtre)
            document.documentElement.style.setProperty('--app-header-height', `${rect.height || 0}px`);
            document.documentElement.style.setProperty('--app-header-offset', `${rect.bottom || 0}px`);
        },
        closeResponsiveMenu() {
            this.$store.state.hiddenBody = false;

            const menu = document.getElementById('navbarNav');
            if (!menu || !menu.classList.contains('show')) return;

            if (window.bootstrap?.Collapse) {
                window.bootstrap.Collapse.getOrCreateInstance(menu).hide();
            } else {
                menu.classList.remove('show');
            }
        },
        handleResponsiveNavClick(event) {
            if (window.innerWidth > 768) return;

            const link = event.target.closest('a');
            if (!link) return;

            const targetPath = new URL(link.href, window.location.origin).pathname;
            if (targetPath !== this.$route.path) return;

            event.preventDefault();
            this.closeResponsiveMenu();
        },
    }
}

</script>

<style>
/* Import font */

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&family=Roboto&display=swap');

/* General header CSS */
html {
    font-size: 14px;
}

body,
html {
    overflow-x: hidden;
}

.header-z {
    z-index: 2001;
}

.navbar-brand img {
    max-height: 48px;
    width: auto;
}

.modal-backdrop {
    z-index: 2100 !important;
}

.modal {
    z-index: 2110 !important;
}

/* Valeur de secours si JS n’a pas encore défini la variable */
:root {
    --app-header-height: 56px;
    --app-header-offset: 56px;
    /* valeur de secours */
}

@media (min-width: 768px) {
    html {
        font-size: 16px;
    }

    .responsive-header-menu {
        justify-content: end;
    }
}

@media (max-width: 768px) {

    .navbar-toggler,
    .navbar-brand {
        z-index: 1;
    }

    .navbar-brand {
        padding: 0;
        margin-left: 0.5rem;
    }

    .navbar-brand img {
        max-height: 38px;
        width: auto;
    }

    .navbar-toggler {
        padding: 0.4rem 0.65rem;
    }

    #navbarNav {
        background-color: #fff;
        position: fixed;
        top: var(--app-header-offset, 56px);
        left: 0;
        right: 0;
        bottom: 0;
        height: auto;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        z-index: 2000;
    }

    .btn-menu,
    .btn-menu-dark {
        height: 100px;
        width: 100%;
        border-radius: 0%;
        border-bottom: #e5e5e5 1px solid;
        text-align: left;
        font-family: 'Roboto', sans-serif;
        font-size: 1.5rem;
        font-weight: bold;
        margin: 0;
        display: flex;
        align-items: center;
    }

    .navbar .dropdown-menu {
        font-family: 'Roboto', sans-serif;
        font-size: 1.5rem;
        font-weight: bold;
        background: #f8f9fb;
        border-top: 1px solid #e9ecef;
        border-bottom: 1px solid #e9ecef;
        box-shadow: none;
    }

    .navbar .dropdown-menu li {
        min-height: 72px;
        display: flex;
        align-items: center;
    }

    .navbar .dropdown-menu .dropdown-item {
        padding-left: 3.25rem !important;
        font-size: 1.2rem;
        font-weight: 600;
        color: #4b5563;
        white-space: normal;
    }

    .btn-logout {
        background-color: #333;
        color: #fff;
        text-align: center;
        margin-left: 0px !important;
        justify-content: center;
        align-items: center;
    }

    .responsive-header-menu {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-height: 0;
    }

    .responsive-header-menu>ul {
        width: 100%;
        flex: 0 0 auto;
        margin-bottom: 0;
    }

    .btn-menu.dropdown-toggle:not(.active-btn):not(.btn-primary):hover,
    .btn-menu.dropdown-toggle:not(.active-btn):not(.btn-primary):focus,
    .btn-menu.dropdown-toggle:not(.active-btn):not(.btn-primary):active,
    .btn-menu.dropdown-toggle.show:not(.active-btn):not(.btn-primary) {
        background-color: transparent !important;
        color: #53595f !important;
        box-shadow: none !important;
    }

    .nav-item.dropdown.d-lg-none>.btn-menu:not(.active-btn):hover,
    .nav-item.dropdown.d-lg-none>.btn-menu:not(.active-btn):focus,
    .nav-item.dropdown.d-lg-none>.btn-menu:not(.active-btn):active,
    .nav-item.dropdown.d-lg-none>.btn-menu.show:not(.active-btn) {
        background-color: transparent !important;
        color: #53595f !important;
        box-shadow: none !important;
    }

    .navbar .dropdown-toggle::after {
        transition: transform 0.2s ease;
    }

    .navbar .dropdown-toggle.show::after {
        transform: rotate(180deg);
    }

    .btn-menu.active-btn,
    .btn-menu-dark.active-btn {
        border-bottom: #e5e5e5 1px solid;
        border-left: 6px solid #0d6efd;
        background: linear-gradient(90deg, rgba(13, 110, 253, 0.14) 0%, rgba(13, 110, 253, 0.04) 100%);
        color: #0b3d91 !important;
        box-shadow: inset 0 0 0 1px rgba(13, 110, 253, 0.08);
    }

    .active-btn .svg-inline--fa,
    .active-btn i {
        color: #0d6efd;
    }
}

.border-bottom {
    border-bottom: 1px solid #e5e5e5;
}

.box-shadow {
    box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05);
}

.client-selector-dialog {
    max-width: 720px;
}

.client-selector-content {
    border: 0;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.18);
}

.client-selector-header {
    border-bottom: 1px solid #f0f0f0;
    padding: 1.25rem 1.25rem 1rem;
    background: linear-gradient(180deg, #ffffff 0%, #fbfbfb 100%);
}

.client-selector-kicker {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #0d6efd;
    margin-bottom: 0.2rem;
}

.client-selector-body {
    padding: 1.25rem;
    background: #fcfcfd;
}

.client-current-box {
    background: #ffffff;
    border: 1px solid #ececec;
    border-radius: 16px;
    padding: 0.9rem 1rem;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.client-current-name {
    font-size: 1.05rem;
    margin-top: 0.15rem;
    color: #1f2937;
}

.client-search-wrap {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fcfcfd;
    padding-bottom: 0.25rem;
}

.client-search-input {
    border-radius: 14px;
    border: 1px solid #e4e7ec;
    min-height: 48px;
    padding: 0.75rem 1rem;
    box-shadow: none;
}

.client-search-input:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.client-selector-list {
    max-height: 50vh;
    overflow-y: auto;
    padding-right: 0.25rem;
}

.client-option {
    width: 100%;
    text-align: left;
    border: 1px solid #ebedf0;
    background: #fff;
    border-radius: 16px;
    padding: 0.95rem 1rem;
    margin-bottom: 0.75rem;
    transition: all 0.18s ease;
}

.client-option:hover {
    transform: translateY(-1px);
    border-color: #cfe2ff;
    box-shadow: 0 10px 22px rgba(13, 110, 253, 0.12);
}

.client-option-active {
    border-color: #0d6efd;
    background: linear-gradient(180deg, #eef4ff 0%, #ffffff 100%);
    box-shadow: 0 12px 26px rgba(13, 110, 253, 0.18);
}

.client-option-title {
    font-weight: 700;
    color: #202939;
}

.client-option-subtitle {
    margin-top: 0.2rem;
    font-size: 0.9rem;
    color: #6b7280;
}

.client-empty-state {
    text-align: center;
    color: #6b7280;
    padding: 1.25rem 1rem;
}

/* Avatar and dropdown menu CSS */
.nav img {
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin: -8px 0;
    float: left;
    margin-right: 10px;
}

.navbar ul li i {
    font-size: 18px;
}

.navbar .dropdown-menu i {
    font-size: 16px;
    min-width: 22px;
}

.navbar .dropdown-menu {
    border-radius: 1px;
    border-color: #e5e5e5;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
}

.navbar .dropdown-menu li a {
    color: #777;
    padding: 8px 20px;
    line-height: normal;
}

.navbar .dropdown-menu li a:hover,
.navbar .dropdown-menu li a:active {
    color: #333;
}

.navbar .dropdown-menu .material-icons {
    font-size: 21px;
    line-height: 16px;
    vertical-align: middle;
    margin-top: -2px;
}

@media (min-width: 1200px) {
    .form-inline .input-group {
        width: 300px;
        margin-left: 30px;
    }
}

@media (max-width: 1199px) {
    .form-inline {
        display: block;
        margin-bottom: 10px;
    }

    .input-group {
        width: 100%;
    }
}

@media (min-width: 769px) {
    .dropdown:hover .dropdown-menu {
        display: block;
    }
}

.btn-menu {
    color: #53595f;
    border: none;
}

.btn-menu-dark {
    background-color: rgb(108 117 125);
    color: white;
}

.btn-menu:hover,
.btn-menu-dark:hover {
    background-color: #ff641e;
    color: white;
}

.active-client {
    background-color: #ff641e;
}

.active-client:hover {
    background-color: #ff641e;
}

.active-btn {
    border-bottom: 4px solid #ff864f;
}

.notification-icon {
    position: relative;
    font-size: 1.2em;
}

.notification-icon span {
    position: absolute !important;
    top: 4px !important;
    right: 2px;
    font-size: 0.4em;
    background-color: #ff641e;
}

.notification-badge {
    background-color: #ff641e;
}
</style>
